interface Props {
  onBack: () => void;
}

const EFFECTIVE = 'August 28, 2026';

export function PrivacyPage({ onBack }: Props) {
  return (
    <article className="legal">
      <button className="btn btn--ghost legal__back" onClick={onBack}>
        ← Back to leaderboard
      </button>
      <h1>Privacy Policy</h1>
      <p className="legal__eff">Effective date: {EFFECTIVE}</p>

      <h2>1. What we collect</h2>
      <p>School Rank (operated by <strong>Eason Books LLC</strong>) collects very little:</p>
      <ul>
        <li>
          <strong>Contribution records</strong> — the school you contributed to, the
          amount, a timestamp, and an optional handle you choose to display. Handles are
          public on the activity feed; leave the field blank to stay anonymous.
        </li>
        <li>
          <strong>Payment data</strong> — handled entirely by <strong>Stripe</strong>.
          We do not receive or store your card number, CVC, or full billing details.
          Stripe returns only a confirmation that a payment succeeded plus limited,
          non-sensitive metadata.
        </li>
        <li>
          <strong>Basic technical data</strong> — standard web/server logs (IP address,
          user agent, timestamps) via our hosting (AWS CloudFront/S3), used for
          security and operations.
        </li>
      </ul>
      <p>
        We do <strong>not</strong> require an account, and we do not ask for your name,
        email, or address to use the leaderboard.
      </p>

      <h2>2. How we use it</h2>
      <p>
        To operate the leaderboard (record and display contributions), process payments
        through Stripe, prevent abuse, and meet legal obligations. We do not sell your
        personal information.
      </p>

      <h2>3. Third parties</h2>
      <ul>
        <li>
          <strong>Stripe</strong> — payment processing (see Stripe’s Privacy Policy).
        </li>
        <li>
          <strong>Amazon Web Services</strong> — hosting and content delivery.
        </li>
      </ul>

      <h2>4. Cookies</h2>
      <p>
        The site itself sets no tracking cookies. Stripe’s hosted checkout may set
        cookies necessary for payment and fraud prevention.
      </p>

      <h2>5. Data retention</h2>
      <p>
        Contribution records are retained to keep the public leaderboard accurate.
        Server logs are retained per our hosting provider’s defaults.
      </p>

      <h2>6. Your rights</h2>
      <p>
        Depending on where you live (e.g. GDPR/CCPA), you may have rights to access or
        delete personal data. Because contributions are largely anonymous, we may need
        additional information to locate records associated with you. Contact us to make
        a request.
      </p>

      <h2>7. Children</h2>
      <p>The service is not directed to children under 13 and we do not knowingly collect their data.</p>

      <h2>8. Contact</h2>
      <p>Privacy questions or requests: admin@easonbooks.com</p>

      <p className="legal__copy">© 2026 Eason Books LLC. All rights reserved. School Rank is operated by Eason Books LLC.</p>
    </article>
  );
}
